import React, { useEffect, useState } from 'react';

const ScrollBackground = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const parallax = (speed) => scrollY * speed;

  return (
    <div className="scroll-animate-container">
      <div style={{ transform: `translateY(${parallax(0.15)}px)` }}>
        <div 
          className="floating-shape floating-circle w-[500px] h-[500px] animate-float-slow"
          style={{ top: '5%', left: '10%' }}
        />
      </div>
      
      <div style={{ transform: `translateY(${parallax(-0.1)}px)` }}>
        <div 
          className="floating-shape floating-circle w-[350px] h-[350px] animate-float-medium"
          style={{ top: '40%', right: '5%', animationDelay: '-3s' }}
        />
      </div>
      
      <div style={{ transform: `translateY(${parallax(-0.08)}px)` }}>
        <div 
          className="floating-shape floating-circle w-[400px] h-[400px] animate-pulse-glow"
          style={{ 
            bottom: '10%', 
            left: '25%',
            background: 'linear-gradient(135deg, rgba(249, 115, 22, 0.12), rgba(251, 191, 36, 0.08))',
          }}
        />
      </div>

      <div style={{ transform: `translateY(${parallax(0.2)}px)` }}>
        <div 
          className="floating-shape floating-ring w-[200px] h-[200px] animate-rotate-slow"
          style={{ top: '20%', right: '15%' }}
        />
      </div>
      
      <div style={{ transform: `translateY(${parallax(-0.12)}px)` }}>
        <div 
          className="floating-shape floating-ring w-[150px] h-[150px] animate-float-fast"
          style={{ top: '60%', left: '8%', borderColor: 'rgba(249, 115, 22, 0.2)', animationDelay: '-5s' }}
        />
      </div>

      <div style={{ transform: `translateY(${parallax(0.25)}px)` }}>
        <div 
          className="floating-shape floating-diamond w-[80px] h-[80px] animate-float-medium"
          style={{ top: '30%', left: '45%', animationDelay: '-2s' }}
        />
      </div>
      
      <div style={{ transform: `translateY(${parallax(-0.15)}px)` }}>
        <div 
          className="floating-shape floating-diamond w-[60px] h-[60px] animate-float-slow"
          style={{ top: '75%', right: '30%', animationDelay: '-7s' }}
        />
      </div>

      <div 
        className="wave-line"
        style={{ top: '25%', animationDelay: '0s' }}
      />
      <div 
        className="wave-line"
        style={{ top: '55%', animationDelay: '-3s' }}
      />
      <div 
        className="wave-line"
        style={{ top: '80%', animationDelay: '-6s' }}
      />

      {[...Array(12)].map((_, i) => (
        <div
          key={i}
          style={{ transform: `translateY(${parallax(0.1 + i * 0.02)}px)` }}
        >
          <div
            className="sparkle-dot"
            style={{
              top: `${10 + (i * 7)}%`,
              left: `${5 + (i * 8)}%`,
              animationDelay: `${i * 0.4}s`,
            }}
          />
        </div>
      ))}

      <div 
        className="absolute w-[600px] h-[600px]"
        style={{
          top: '50%',
          left: '50%',
          marginTop: '-300px',
          marginLeft: '-300px',
          border: '1px solid rgba(251, 191, 36, 0.05)',
          borderRadius: '50%',
          transform: `rotate(${scrollY * 0.05}deg)`,
        }}
      />
      <div 
        className="absolute w-[800px] h-[800px]"
        style={{
          top: '50%',
          left: '50%',
          marginTop: '-400px',
          marginLeft: '-400px',
          border: '1px dashed rgba(251, 191, 36, 0.03)',
          borderRadius: '50%',
          transform: `rotate(${-scrollY * 0.03}deg)`,
        }}
      />
    </div>
  );
};

export default ScrollBackground;
